let Utils = {

  //Convert Book Type to String
  bookTypeResolver(bookType) {
    let type;
    switch (bookType) {
      case 'Published':
        type = "Σύγγραμμα";
        break;
      case 'eBook':
        type = "Ηλεκτρονικό Βιβλίο";
        break;
      case 'ProfessorNotes':
        type = "Σημειώσεις";
        break;
      case 'UniversityPress':
        type = "Πανεπιστημιακές εκδόσεις";
        break;
      case 'Free':
        type = "Ελεύθερο";
        break;
      case 'ePublished':
        type = "Ηλεκτρονικό Σύγγραμμα";
        break;
      default:
        type = "ΑΛΛΟ";
        break;
    }
    return type;
  },

  bookTitleSummary(title, type, volNumber, authors, publicYear, editHouse, isbn) {
    let sum = '';
    if (title != null)
      sum += title + ', ';
    if (type != null)
      sum += this.bookTypeResolver(type) + ', ';
    if (volNumber != null)
      sum += volNumber + ', ';
    if (authors != null)
      sum += authors + ', ';
    if (publicYear != null)
      sum += publicYear + ', ';
    if (editHouse != null)
      sum += editHouse + ', ';
    if (isbn != null)
      sum += 'ISBN: ' + isbn;

    if (sum != null && sum != '')
      return sum;
    else
      return "Δεν υπάρχει διαθέσιμος Τίτλος για το Βιβλίο";
  },

  departmentMapResolver(resultArray) {
    let tableMap = [];
    if (resultArray != null) {
      for (let i = 0; i < resultArray.length; i++)
        tableMap.push({
          institution: resultArray[i].institution.name,
          academic: resultArray[i].academic.department,
          secretariatId: resultArray[i].secretariat.id
        });
      return tableMap;
    }
  },

  availabilityMapResolver(resultArray, selectedYear) {
    let tableMap = [];
    if (resultArray != null) {
      for (let i = 0; i < resultArray.length; i++)
        tableMap.push({
          bookId: resultArray[i].bookId,
          bookTitle: resultArray[i].bookTitle,
          bookTotal: resultArray[i].total,
          selectedYear: selectedYear
        });
      return tableMap;
    }
  },

  publisherBooksMapResolver(resultArray) {
    let tableMap = [];
    for (let i = 0; i < resultArray.length; i++)
      tableMap.push({
        bookId: resultArray[i].bookId,
        bookTitle: resultArray[i].bookTitle,
        total: resultArray[i].total,
        delivered: resultArray[i].delivered
      });
    return tableMap;
  },

  getPublisherOptions(result) {
    let options = [];
    for (let i = 0; i < result.length; i++)
      options.push({value: result[i].id, text: result[i].publisherName});

    return options;
  },

  getPublisherDtoById(publisherId, array) {

    for (let i = 0; i < array.length; i++)
      if (publisherId === array[i].id)
        return array[i];

    return null;
  },

  parseCorrectDate(today) {
    // let array = input.split("-");
    // return array[2] + "/" + array[1] + "/" + array[0];

    let dd = today.getDate();
    let mm = today.getMonth()+1; //January is 0!

    let yyyy = today.getFullYear();
    if(dd<10){
      dd='0'+dd;
    }
    if(mm<10){
      mm='0'+mm;
    }

    return dd+'/'+mm+'/'+yyyy;
  },

  compareAcademic(a, b) {
    if (a.academicName < b.academicName)
      return -1;
    if (a.academicName > b.academicName)
      return 1;
    return 0;
  },

  compareBooks(a, b) {
    if (a.books < b.books)
      return -1;
    if (a.books > b.books)
      return 1;
    return 0;
  }
};

export default Utils;



// WEBPACK FOOTER //
// ./src/js/AppUtilities.js